/** HubSpot mark used in hero announcement eyebrow and automation flow visuals. */
export const HUBSPOT_ICON_SRC = "/assets/imgs/hubspot-icon.png";
